// extracted by mini-css-extract-plugin
module.exports = {"root":"FamilyNode_root__3u_Jo","inner":"FamilyNode_inner__3WTVr","isRoot":"FamilyNode_isRoot__3kzUm"};